export const environment = process.env.NODE_ENV
export const platformURL = process.env.REACT_APP_DIA_API_LOCATION || 'http://api.institutodia.local/se/'
export const lmsPlataformURL = process.env.REACT_APP_DIA_LMS_API_LOCATION || 'http://api.institutodia.local/se/lms/'
export const appURL = process.env.REACT_APP_URL || 'http://react-lms.local:3002/'
export const platformBearerToken = process.env.REACT_APP_DIA_API_BEARER_TOKEN || false
export const appDomain = process.env.REACT_APP_DIA_DOMAIN || false
export const appVersion = process.env.REACT_APP_VERSION || 'Servicios Escolares Instituto DIA'
